// countries.ts
export const COUNTRIES = [
  { code: 'AF', en: 'Afghanistan', ko: '아프가니스탄' },
  { code: 'AL', en: 'Albania', ko: '알바니아' },
  { code: 'DZ', en: 'Algeria', ko: '알제리' },
  { code: 'AS', en: 'American Samoa', ko: '아메리칸 사모아' },
  { code: 'AD', en: 'Andorra', ko: '안도라' },
  { code: 'AO', en: 'Angola', ko: '앙골라' },
  { code: 'AI', en: 'Anguilla', ko: '앵귈라' },
  { code: 'AQ', en: 'Antarctica', ko: '남극' },
  { code: 'AG', en: 'Antigua and Barbuda', ko: '앤티가 바부다' },
  { code: 'AR', en: 'Argentina', ko: '아르헨티나' },
  { code: 'AM', en: 'Armenia', ko: '아르메니아' },
  { code: 'AW', en: 'Aruba', ko: '아루바' },
  { code: 'AU', en: 'Australia', ko: '호주' },
  { code: 'AT', en: 'Austria', ko: '오스트리아' },
  { code: 'AZ', en: 'Azerbaijan', ko: '아제르바이잔' },
  { code: 'BS', en: 'Bahamas', ko: '바하마' },
  { code: 'BH', en: 'Bahrain', ko: '바레인' },
  { code: 'BD', en: 'Bangladesh', ko: '방글라데시' },
  { code: 'BB', en: 'Barbados', ko: '바베이도스' },
  { code: 'BY', en: 'Belarus', ko: '벨라루스' },
  { code: 'BE', en: 'Belgium', ko: '벨기에' },
  { code: 'BZ', en: 'Belize', ko: '벨리즈' },
  { code: 'BJ', en: 'Benin', ko: '베냉' },
  { code: 'BM', en: 'Bermuda', ko: '버뮤다' },
  { code: 'BT', en: 'Bhutan', ko: '부탄' },
  { code: 'BO', en: 'Bolivia (Plurinational State of)', ko: '볼리비아' },
  { code: 'BQ', en: 'Bonaire, Sint Eustatius and Saba', ko: '보네르, 신트외스타티위스, 사바' },
  { code: 'BA', en: 'Bosnia and Herzegovina', ko: '보스니아 헤르체고비나' },
  { code: 'BW', en: 'Botswana', ko: '보츠와나' },
  { code: 'BV', en: 'Bouvet Island', ko: '부베섬' },
  { code: 'BR', en: 'Brazil', ko: '브라질' },
  { code: 'IO', en: 'British Indian Ocean Territory', ko: '영국령 인도양 지역' },
  { code: 'BN', en: 'Brunei Darussalam', ko: '브루나이' },
  { code: 'BG', en: 'Bulgaria', ko: '불가리아' },
  { code: 'BF', en: 'Burkina Faso', ko: '부르키나파소' },
  { code: 'BI', en: 'Burundi', ko: '부룬디' },
  { code: 'CV', en: 'Cabo Verde', ko: '카보베르데' },
  { code: 'KH', en: 'Cambodia', ko: '캄보디아' },
  { code: 'CM', en: 'Cameroon', ko: '카메룬' },
  { code: 'CA', en: 'Canada', ko: '캐나다' },
  { code: 'KY', en: 'Cayman Islands', ko: '케이맨 제도' },
  { code: 'CF', en: 'Central African Republic', ko: '중앙아프리카공화국' },
  { code: 'TD', en: 'Chad', ko: '차드' },
  { code: 'CL', en: 'Chile', ko: '칠레' },
  { code: 'CN', en: 'China', ko: '중국' },
  { code: 'CX', en: 'Christmas Island', ko: '크리스마스섬' },
  { code: 'CC', en: 'Cocos (Keeling) Islands', ko: '코코스(킬링) 제도' },
  { code: 'CO', en: 'Colombia', ko: '콜롬비아' },
  { code: 'KM', en: 'Comoros', ko: '코모로' },
  { code: 'CG', en: 'Congo', ko: '콩고' },
  { code: 'CD', en: 'Congo, Democratic Republic of the', ko: '콩고민주공화국' },
  { code: 'CK', en: 'Cook Islands', ko: '쿡 제도' },
  { code: 'CR', en: 'Costa Rica', ko: '코스타리카' },
  { code: 'CI', en: 'Côte d\'Ivoire', ko: '코트디부아르' },
  { code: 'HR', en: 'Croatia', ko: '크로아티아' },
  { code: 'CU', en: 'Cuba', ko: '쿠바' },
  { code: 'CW', en: 'Curaçao', ko: '퀴라소' },
  { code: 'CY', en: 'Cyprus', ko: '키프로스' },
  { code: 'CZ', en: 'Czechia', ko: '체코' },
  { code: 'DK', en: 'Denmark', ko: '덴마크' },
  { code: 'DJ', en: 'Djibouti', ko: '지부티' },
  { code: 'DM', en: 'Dominica', ko: '도미니카' },
  { code: 'DO', en: 'Dominican Republic', ko: '도미니카공화국' },
  { code: 'EC', en: 'Ecuador', ko: '에콰도르' },
  { code: 'EG', en: 'Egypt', ko: '이집트' },
  { code: 'SV', en: 'El Salvador', ko: '엘살바도르' },
  { code: 'GQ', en: 'Equatorial Guinea', ko: '적도 기니' },
  { code: 'ER', en: 'Eritrea', ko: '에리트레아' },
  { code: 'EE', en: 'Estonia', ko: '에스토니아' },
  { code: 'SZ', en: 'Eswatini', ko: '에스와티니' },
  { code: 'ET', en: 'Ethiopia', ko: '에티오피아' },
  { code: 'FK', en: 'Falkland Islands (Malvinas)', ko: '포클랜드 제도' },
  { code: 'FO', en: 'Faroe Islands', ko: '페로 제도' },
  { code: 'FJ', en: 'Fiji', ko: '피지' },
  { code: 'FI', en: 'Finland', ko: '핀란드' },
  { code: 'FR', en: 'France', ko: '프랑스' },
  { code: 'GF', en: 'French Guiana', ko: '프랑스령 기아나' },
  { code: 'PF', en: 'French Polynesia', ko: '프랑스령 폴리네시아' },
  { code: 'TF', en: 'French Southern Territories', ko: '프랑스 남부와 남극 지역' },
  { code: 'GA', en: 'Gabon', ko: '가봉' },
  { code: 'GM', en: 'Gambia', ko: '감비아' },
  { code: 'GE', en: 'Georgia', ko: '조지아' },
  { code: 'DE', en: 'Germany', ko: '독일' },
  { code: 'GH', en: 'Ghana', ko: '가나' },
  { code: 'GI', en: 'Gibraltar', ko: '지브롤터' },
  { code: 'GR', en: 'Greece', ko: '그리스' },
  { code: 'GL', en: 'Greenland', ko: '그린란드' },
  { code: 'GD', en: 'Grenada', ko: '그레나다' },
  { code: 'GP', en: 'Guadeloupe', ko: '과들루프' },
  { code: 'GU', en: 'Guam', ko: '괌' },
  { code: 'GT', en: 'Guatemala', ko: '과테말라' },
  { code: 'GG', en: 'Guernsey', ko: '건지 섬' },
  { code: 'GN', en: 'Guinea', ko: '기니' },
  { code: 'GW', en: 'Guinea-Bissau', ko: '기니비사우' },
  { code: 'GY', en: 'Guyana', ko: '가이아나' },
  { code: 'HT', en: 'Haiti', ko: '아이티' },
  { code: 'HM', en: 'Heard Island and McDonald Islands', ko: '허드 맥도널드 제도' },
  { code: 'VA', en: 'Holy See', ko: '교황청(바티칸 시국)' },
  { code: 'HN', en: 'Honduras', ko: '온두라스' },
  { code: 'HK', en: 'Hong Kong', ko: '홍콩' },
  { code: 'HU', en: 'Hungary', ko: '헝가리' },
  { code: 'IS', en: 'Iceland', ko: '아이슬란드' },
  { code: 'IN', en: 'India', ko: '인도' },
  { code: 'ID', en: 'Indonesia', ko: '인도네시아' },
  { code: 'IR', en: 'Iran (Islamic Republic of)', ko: '이란' },
  { code: 'IQ', en: 'Iraq', ko: '이라크' },
  { code: 'IE', en: 'Ireland', ko: '아일랜드' },
  { code: 'IM', en: 'Isle of Man', ko: '맨섬' },
  { code: 'IL', en: 'Israel', ko: '이스라엘' },
  { code: 'IT', en: 'Italy', ko: '이탈리아' },
  { code: 'JM', en: 'Jamaica', ko: '자메이카' },
  { code: 'JP', en: 'Japan', ko: '일본' },
  { code: 'JE', en: 'Jersey', ko: '저지 섬' },
  { code: 'JO', en: 'Jordan', ko: '요르단' },
  { code: 'KZ', en: 'Kazakhstan', ko: '카자흐스탄' },
  { code: 'KE', en: 'Kenya', ko: '케냐' },
  { code: 'KI', en: 'Kiribati', ko: '키리바시' },
  { code: 'KP', en: 'Korea (Democratic People\'s Republic of)', ko: '조선민주주의인민공화국' },
  { code: 'KR', en: 'Korea, Republic of', ko: '대한민국' },
  { code: 'KW', en: 'Kuwait', ko: '쿠웨이트' },
  { code: 'KG', en: 'Kyrgyzstan', ko: '키르기스스탄' },
  { code: 'LA', en: 'Lao People\'s Democratic Republic', ko: '라오스' },
  { code: 'LV', en: 'Latvia', ko: '라트비아' },
  { code: 'LB', en: 'Lebanon', ko: '레바논' },
  { code: 'LS', en: 'Lesotho', ko: '레소토' },
  { code: 'LR', en: 'Liberia', ko: '라이베리아' },
  { code: 'LY', en: 'Libya', ko: '리비아' },
  { code: 'LI', en: 'Liechtenstein', ko: '리히텐슈타인' },
  { code: 'LT', en: 'Lithuania', ko: '리투아니아' },
  { code: 'LU', en: 'Luxembourg', ko: '룩셈부르크' },
  { code: 'MO', en: 'Macao', ko: '마카오' },
  { code: 'MG', en: 'Madagascar', ko: '마다가스카르' },
  { code: 'MW', en: 'Malawi', ko: '말라위' },
  { code: 'MY', en: 'Malaysia', ko: '말레이시아' },
  { code: 'MV', en: 'Maldives', ko: '몰디브' },
  { code: 'ML', en: 'Mali', ko: '말리' },
  { code: 'MT', en: 'Malta', ko: '몰타' },
  { code: 'MH', en: 'Marshall Islands', ko: '마셜 제도' },
  { code: 'MQ', en: 'Martinique', ko: '마르티니크' },
  { code: 'MR', en: 'Mauritania', ko: '모리타니' },
  { code: 'MU', en: 'Mauritius', ko: '모리셔스' },
  { code: 'YT', en: 'Mayotte', ko: '마요트' },
  { code: 'MX', en: 'Mexico', ko: '멕시코' },
  { code: 'FM', en: 'Micronesia (Federated States of)', ko: '미크로네시아 연방' },
  { code: 'MD', en: 'Moldova, Republic of', ko: '몰도바' },
  { code: 'MC', en: 'Monaco', ko: '모나코' },
  { code: 'MN', en: 'Mongolia', ko: '몽골' },
  { code: 'ME', en: 'Montenegro', ko: '몬테네그로' },
  { code: 'MS', en: 'Montserrat', ko: '몬트세랫' },
  { code: 'MA', en: 'Morocco', ko: '모로코' },
  { code: 'MZ', en: 'Mozambique', ko: '모잠비크' },
  { code: 'MM', en: 'Myanmar', ko: '미얀마' },
  { code: 'NA', en: 'Namibia', ko: '나미비아' },
  { code: 'NR', en: 'Nauru', ko: '나우루' },
  { code: 'NP', en: 'Nepal', ko: '네팔' },
  { code: 'NL', en: 'Netherlands', ko: '네덜란드' },
  { code: 'NC', en: 'New Caledonia', ko: '뉴칼레도니아' },
  { code: 'NZ', en: 'New Zealand', ko: '뉴질랜드' },
  { code: 'NI', en: 'Nicaragua', ko: '니카라과' },
  { code: 'NE', en: 'Niger', ko: '니제르' },
  { code: 'NG', en: 'Nigeria', ko: '나이지리아' },
  { code: 'NU', en: 'Niue', ko: '니우에' },
  { code: 'NF', en: 'Norfolk Island', ko: '노퍽 섬' },
  { code: 'MK', en: 'North Macedonia', ko: '북마케도니아' },
  { code: 'MP', en: 'Northern Mariana Islands', ko: '북마리아나 제도' },
  { code: 'NO', en: 'Norway', ko: '노르웨이' },
  { code: 'OM', en: 'Oman', ko: '오만' },
  { code: 'PK', en: 'Pakistan', ko: '파키스탄' },
  { code: 'PW', en: 'Palau', ko: '팔라우' },
  { code: 'PS', en: 'Palestine, State of', ko: '팔레스타인' },
  { code: 'PA', en: 'Panama', ko: '파나마' },
  { code: 'PG', en: 'Papua New Guinea', ko: '파푸아뉴기니' },
  { code: 'PY', en: 'Paraguay', ko: '파라과이' },
  { code: 'PE', en: 'Peru', ko: '페루' },
  { code: 'PH', en: 'Philippines', ko: '필리핀' },
  { code: 'PN', en: 'Pitcairn', ko: '핏케언 제도' },
  { code: 'PL', en: 'Poland', ko: '폴란드' },
  { code: 'PT', en: 'Portugal', ko: '포르투갈' },
  { code: 'PR', en: 'Puerto Rico', ko: '푸에르토리코' },
  { code: 'QA', en: 'Qatar', ko: '카타르' },
  { code: 'RE', en: 'Réunion', ko: '레위니옹' },
  { code: 'RO', en: 'Romania', ko: '루마니아' },
  { code: 'RU', en: 'Russian Federation', ko: '러시아' },
  { code: 'RW', en: 'Rwanda', ko: '르완다' },
  { code: 'BL', en: 'Saint Barthélemy', ko: '생바르텔레미' },
  { code: 'SH', en: 'Saint Helena, Ascension and Tristan da Cunha', ko: '세인트헬레나, 어센션, 트리스탄다쿠냐' },
  { code: 'KN', en: 'Saint Kitts and Nevis', ko: '세인트키츠 네비스' },
  { code: 'LC', en: 'Saint Lucia', ko: '세인트루시아' },
  { code: 'MF', en: 'Saint Martin (French part)', ko: '생마르탱(프랑스령)' },
  { code: 'PM', en: 'Saint Pierre and Miquelon', ko: '생피에르 미클롱' },
  { code: 'VC', en: 'Saint Vincent and the Grenadines', ko: '세인트빈센트 그레나딘' },
  { code: 'WS', en: 'Samoa', ko: '사모아' },
  { code: 'SM', en: 'San Marino', ko: '산마리노' },
  { code: 'ST', en: 'Sao Tome and Principe', ko: '상투메 프린시페' },
  { code: 'SA', en: 'Saudi Arabia', ko: '사우디아라비아' },
  { code: 'SN', en: 'Senegal', ko: '세네갈' },
  { code: 'RS', en: 'Serbia', ko: '세르비아' },
  { code: 'SC', en: 'Seychelles', ko: '세이셸' },
  { code: 'SL', en: 'Sierra Leone', ko: '시에라리온' },
  { code: 'SG', en: 'Singapore', ko: '싱가포르' },
  { code: 'SX', en: 'Sint Maarten (Dutch part)', ko: '신트마르턴(네덜란드령)' },
  { code: 'SK', en: 'Slovakia', ko: '슬로바키아' },
  { code: 'SI', en: 'Slovenia', ko: '슬로베니아' },
  { code: 'SB', en: 'Solomon Islands', ko: '솔로몬 제도' },
  { code: 'SO', en: 'Somalia', ko: '소말리아' },
  { code: 'ZA', en: 'South Africa', ko: '남아프리카공화국' },
  { code: 'GS', en: 'South Georgia and the South Sandwich Islands', ko: '사우스조지아 사우스샌드위치 제도' },
  { code: 'SS', en: 'South Sudan', ko: '남수단' },
  { code: 'ES', en: 'Spain', ko: '스페인' },
  { code: 'LK', en: 'Sri Lanka', ko: '스리랑카' },
  { code: 'SD', en: 'Sudan', ko: '수단' },
  { code: 'SR', en: 'Suriname', ko: '수리남' },
  { code: 'SJ', en: 'Svalbard and Jan Mayen', ko: '스발바르 얀마옌' },
  { code: 'SE', en: 'Sweden', ko: '스웨덴' },
  { code: 'CH', en: 'Switzerland', ko: '스위스' },
  { code: 'SY', en: 'Syrian Arab Republic', ko: '시리아' },
  { code: 'TW', en: 'Taiwan, Province of China', ko: '대만' },
  { code: 'TJ', en: 'Tajikistan', ko: '타지키스탄' },
  { code: 'TZ', en: 'Tanzania, United Republic of', ko: '탄자니아' },
  { code: 'TH', en: 'Thailand', ko: '태국' },
  { code: 'TL', en: 'Timor-Leste', ko: '동티모르' },
  { code: 'TG', en: 'Togo', ko: '토고' },
  { code: 'TK', en: 'Tokelau', ko: '토켈라우' },
  { code: 'TO', en: 'Tonga', ko: '통가' },
  { code: 'TT', en: 'Trinidad and Tobago', ko: '트리니다드 토바고' },
  { code: 'TN', en: 'Tunisia', ko: '튀니지' },
  { code: 'TR', en: 'Türkiye', ko: '튀르키예' },
  { code: 'TM', en: 'Turkmenistan', ko: '투르크메니스탄' },
  { code: 'TC', en: 'Turks and Caicos Islands', ko: '터크스 케이커스 제도' },
  { code: 'TV', en: 'Tuvalu', ko: '투발루' },
  { code: 'UG', en: 'Uganda', ko: '우간다' },
  { code: 'UA', en: 'Ukraine', ko: '우크라이나' },
  { code: 'AE', en: 'United Arab Emirates', ko: '아랍에미리트' },
  { code: 'GB', en: 'United Kingdom of Great Britain and Northern Ireland', ko: '영국' },
  { code: 'US', en: 'United States of America', ko: '미국' },
  { code: 'UM', en: 'United States Minor Outlying Islands', ko: '미국령 군소 제도' },
  { code: 'UY', en: 'Uruguay', ko: '우루과이' },
  { code: 'UZ', en: 'Uzbekistan', ko: '우즈베키스탄' },
  { code: 'VU', en: 'Vanuatu', ko: '바누아투' },
  { code: 'VE', en: 'Venezuela (Bolivarian Republic of)', ko: '베네수엘라' },
  { code: 'VN', en: 'Viet Nam', ko: '베트남' },
  { code: 'VG', en: 'Virgin Islands (British)', ko: '영국령 버진아일랜드' },
  { code: 'VI', en: 'Virgin Islands (U.S.)', ko: '미국령 버진아일랜드' },
  { code: 'WF', en: 'Wallis and Futuna', ko: '월리스 푸투나' },
  { code: 'EH', en: 'Western Sahara', ko: '서사하라' },
  { code: 'YE', en: 'Yemen', ko: '예멘' },
  { code: 'ZM', en: 'Zambia', ko: '잠비아' },
  { code: 'ZW', en: 'Zimbabwe', ko: '짐바브웨' },
]
